
const messagesForBuilder = ({ appkey, goalId, iconClass, title, cardLabel }) => {
  const bodyText = appkey === 'goalTypes' ? 'Answer the questions to help us meet your financial goals.' : 'Please enter a sum of all your current accounts here';

  return {
    [`${appkey}.${goalId}`]: title,
    [`${appkey}.${goalId}.cardLabel`]: `<i class="${iconClass}"></i> ${cardLabel || title}`,
    [`${appkey}.${goalId}.icon`]: iconClass,
    [`${goalId}.cardBuilder.title`]: title,
    [`${goalId}.cardBuilder.body`]: `<i class="${iconClass}"></i><div>${title}</div><span>${ bodyText }</span>`,
  }
};

export default messagesForBuilder;
